<template>
    <el-collapse-item
        :title="title"
        :name="name"
        class="base-collapse-item"
        v-bind="$attrs"
        v-on="listeners"
    >
        <slot />
        <template
            v-if="$slots.title"
            #title
        >
            <slot name="title" />
        </template>
    </el-collapse-item>
</template>

<script setup lang="ts">
import { useListeners } from 'vue'
import { TranslateResult } from 'vue-i18n'
import { CollapseItem as ElCollapseItem } from 'element-ui'

const listeners = useListeners()

defineProps<{
    name: string
    title?: string | TranslateResult
}>()
</script>
